import React from 'react';
import { useIntl } from 'react-intl';

import { Box } from '~/eds/src/components/Box/Box';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { MenuOption } from '~/eds/src/components/Menu/subcomponents/MenuOption';
import { Option } from '~/eds/src/types/Option';
import { useRouting } from '~/routing/useRouting';
import { Uuid } from '~/types/Uuid';

import { Clause } from '../../../../types';
import { formatUrl } from '../../../../utils';

interface Props {
  clause: Clause;
}

export const ClauseSummary = ({ clause }: Props) => {
  const intl = useIntl();
  const { navigate } = useRouting();

  const options: Option<Uuid>[] = clause.variations.map((variation) => ({
    label: variation.name,
    leftContent: <Box pl={8} />, // left padding to align with accordion header text
    pathname: formatUrl(variation.tab, variation.clauseId, variation.id),
    description: intl.formatMessage(
      {
        id: 'ClauseSummary.variationDescription',
        defaultMessage:
          '{variationsCount} variations across {contractsCount} contracts',
        description:
          'Description showing variation count and contract count. Example: variationsCount = "5", contractsCount = "25"',
      },
      {
        variationsCount: variation.variationsCount,
        contractsCount: variation.contractsCount,
      },
    ),
    value: variation.id,
  }));

  const handleOptionClick = (pathname: string) => {
    navigate(pathname);
  };

  return (
    <Layout direction="column">
      {options.map((option) => (
        <MenuOption
          key={option.value}
          option={option}
          onClick={() => handleOptionClick(option.pathname!)}
        />
      ))}
    </Layout>
  );
};
